module.exports = __webpack_public_path__ + "img/ic-noti-important.72ab9a1b.svg";